import { EUserRoles } from '@enums/roles'

export enum routersPath {
  LOGIN_PAGE = '/',
  NOT_FOUND = '/not_found',
  MAIN_PAGE = '/main',
  USERS = '/users',
  CRMS = '/crms',
  SALARY = '/salary',
  EXPENSES = '/expenses',
  INCOMES = '/incomes',
  REPORTS = '/reports',
  REPORT = '/report',
  USER = '/user',
  CRM = '/crm',
  CRM_STAT = '/crm/stat',
  CRM_PAYMENTS = '/crm/payments',
  CRM_SUBSCRIPTIONS = '/crm/subscriptions',
  BILLING = '/billing',
  SEARCH = '/search',
  SEARCH_USER = '/search/user',
  TARIFFS = '/tariffs',
  COUNTRIES = '/countries',
  AUTOMATION = '/automation',
  USER_PERSONAL_ACCOUNTS = '/client-cabinets',
  PERSONAS_ACCOUNT_DOMAINS = '/domains',
  CABINET_INFO = '/cabinets/:cabinetId',
}

export const getDefaultPathByRole = (role?: EUserRoles): routersPath => {
  switch (role) {
    case EUserRoles.BOSS:
      return routersPath.SEARCH
    case EUserRoles.SUPER_ADMIN:
      return routersPath.MAIN_PAGE
    case EUserRoles.ACCOUNTANT:
      return routersPath.REPORTS
    default:
      return routersPath.LOGIN_PAGE
  }
}
